import { useMemo } from 'react';
import useAppShellTheme from './useAppShellTheme';
import { createAppShellSx } from '../styles/appShellLayout';

export default function useAppShellSx() {
  const tokens = useAppShellTheme();
  return useMemo(() => createAppShellSx(tokens), [tokens]);
}
